<div class="py-4 container-fluid compensation-summary-page">
  <h4 class="mb-4 compensation-summary-title">
    การจัดการคำขอสอนชดเชย - สรุปค่าสอนเกินภาระงาน
  </h4>

  <div class="compensation-summary-card">
    <div class="compensation-summary-card-body">
      <div class="compensation-summary-tabs-header">
        <div class="segmented-tabs compensation-summary-tabs" role="tablist" aria-label="สรุปค่าสอนเกินภาระงาน">
          <button
            type="button"
            id="compensation-summary-tab-requests"
            class="segmented-tab compensation-summary-tab"
            role="tab"
            aria-controls="compensation-summary-panel-requests"
            [attr.aria-selected]="activeTab() === 'requests'"
            [class.active]="activeTab() === 'requests'"
            (click)="onTabChange('requests')"
          >
            สรุปการรับรองคำขอชดเชย
          </button>
          <button
            type="button"
            id="compensation-summary-tab-compensation"
            class="segmented-tab compensation-summary-tab"
            role="tab"
            aria-controls="compensation-summary-panel-compensation"
            [attr.aria-selected]="activeTab() === 'compensation'"
            [class.active]="activeTab() === 'compensation'"
            (click)="onTabChange('compensation')"
          >
            สรุปค่าสอนเกินภาระงาน
          </button>
        </div>
      </div>

      <div class="compensation-summary-tab-content-card">
        <div class="compensation-summary-state" *ngIf="isLoading()">
          กำลังโหลดข้อมูลสรุปค่าสอนเกินภาระงาน...
        </div>

        <div class="compensation-summary-state compensation-summary-state-error" *ngIf="!isLoading() && hasLoadError()">
          ไม่สามารถโหลดข้อมูลสรุปค่าสอนเกินภาระงานได้ กรุณาลองใหม่อีกครั้ง
        </div>

      <ng-template #comparisonIndexTemplate let-row="row">
        {{ row.sequence }}
      </ng-template>

      <ng-template #comparisonSystemRequestTemplate let-row="row">
        <ng-container *ngIf="row.systemRequest as request; else emptyComparisonCell">
          <div class="compensation-summary-request-line">
            <strong class="compensation-summary-request-title">{{ formatRequestTitle(request) }}</strong>
            <ng-container *ngIf="formatScheduledTeachingSlots(request) as teachingSlots">
              <span class="compensation-summary-scheduled-time" *ngIf="teachingSlots.length === 0">
                เวลาที่สอน -
              </span>
              <span class="compensation-summary-scheduled-time" *ngFor="let teachingSlot of teachingSlots">
              {{ teachingSlot }}
              </span>
            </ng-container>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #comparisonErpRequestTemplate let-row="row">
        <ng-container *ngIf="row.erpRequest as erpRequest; else emptyComparisonCell">
          <div class="compensation-summary-request-line">
            <strong>{{ formatErpLeaveDate(row) }}</strong>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #comparisonOfficialTripRequestTemplate let-row="row">
        <ng-container *ngIf="row.officialTripRequest as officialTripRequest; else emptyComparisonCell">
          <div class="compensation-summary-request-line">
            <strong>{{ formatOfficialTripDate(row) }}</strong>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #comparisonLeaveDateTemplate let-row="row">
        <span class="compensation-summary-comparison-date">{{ formatLeaveDate(row) }}</span>
      </ng-template>

      <ng-template #comparisonMakeupTeachingTemplate let-row="row">
        <span class="compensation-summary-makeup-date-time">
          <span>{{ formatMakeupTeachingDate(row) }}</span>
          <span class="compensation-summary-makeup-time">
            {{ formatMakeupTeachingTimeWithHours(row) }}
          </span>
        </span>
      </ng-template>

      <ng-template #comparisonCalculatedMakeupHoursTemplate let-row="row">
        <strong class="compensation-summary-calculated-hours">
          {{ formatCalculatedMakeupHours(row) }}
        </strong>
      </ng-template>

      <ng-template #comparisonStatusTemplate let-row="row">
        <span
          class="compensation-summary-comparison-badge"
          [ngClass]="getComparisonBadgeClass(row.comparisonStatus)"
        >
          {{ row.comparisonLabel }}
        </span>
      </ng-template>

      <ng-template #courseLevelTemplate let-row="row">
        <span class="compensation-summary-course-level">
          {{ row.level }}
        </span>
      </ng-template>

      <ng-template #courseSubjectCodeTemplate let-row="row">
        <ng-container *ngIf="row.rowType === 'total'; else courseSubjectDetail">
          <span class="compensation-summary-course-total-label">รวมทั้งหมด</span>
        </ng-container>
        <ng-template #courseSubjectDetail>
          <span class="compensation-summary-course-code">
            {{ row.subjectCode }}
          </span>
        </ng-template>
      </ng-template>

      <ng-template #courseSubjectNameTemplate let-row="row">
        <span class="compensation-summary-course-name" *ngIf="row.rowType !== 'total'">
          {{ row.subjectName }}
        </span>
      </ng-template>

      <ng-template #courseStudentCountTemplate let-row="row">
        {{ formatStudents(row.studentCount) }}
      </ng-template>

      <ng-template #courseNumberTemplate let-value="value">
        {{ formatTableNumber(value) }}
      </ng-template>

      <ng-template #courseNonNegativeNumberTemplate let-value="value">
        {{ formatNonNegativeTableNumber(value) }}
      </ng-template>

      <ng-template #coursePayableHoursTemplate let-row="row">
        <span class="compensation-summary-course-positive">
          {{ formatTableNumber(row.payableHours) }}
        </span>
      </ng-template>

      <ng-template #courseRateTemplate let-row="row">
        {{ formatRate(row.rateLabel) }}
      </ng-template>

      <ng-template #courseCompensationAmountTemplate let-row="row">
        <span class="compensation-summary-course-positive">
          {{ formatCurrency(row.compensationAmount) }}<ng-container *ngIf="row.rowType === 'total'"> บาท</ng-container>
        </span>
      </ng-template>

      <div
        id="compensation-summary-panel-compensation"
        class="compensation-summary-tab-panel"
        role="tabpanel"
        aria-labelledby="compensation-summary-tab-compensation"
        *ngIf="activeTab() === 'compensation'"
      >
        <div
          class="compensation-summary-toolbar compensation-summary-compensation-toolbar"
          [formGroup]="compensationFilterForm"
        >
          <div class="compensation-summary-filter">
            <app-select
              label="เทอมการศึกษา"
              formControlName="academicTerm"
              [options]="academicTermOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="compensation-summary-select"
              classes="mb-0"
            ></app-select>
          </div>

          <div class="compensation-summary-filter">
            <app-select
              label="ปีการศึกษา"
              formControlName="year"
              [options]="yearOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="compensation-summary-select"
              classes="mb-0"
            ></app-select>
          </div>
        </div>

        <div
          class="segmented-tabs compensation-summary-course-tabs"
          role="tablist"
          aria-label="เลือกหลักสูตรสำหรับตารางสรุปค่าสอนเกินภาระงาน"
        >
          <button
            type="button"
            id="compensation-summary-course-tab-regular"
            class="segmented-tab compensation-summary-course-tab"
            role="tab"
            aria-controls="compensation-summary-course-panel"
            [attr.aria-selected]="activeCourseSummaryTab() === 'regular'"
            [class.active]="activeCourseSummaryTab() === 'regular'"
            (click)="onCourseSummaryTabChange('regular')"
          >
            <span class="compensation-summary-course-tab-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <path d="M5.75 4.5h4.1c1.18 0 2.15.96 2.15 2.15V19c0-1.18-.97-2.15-2.15-2.15h-4.1A1.75 1.75 0 0 1 4 15.1V6.25c0-.97.78-1.75 1.75-1.75Z" />
                <path d="M18.25 4.5h-4.1A2.15 2.15 0 0 0 12 6.65V19c0-1.18.97-2.15 2.15-2.15h4.1A1.75 1.75 0 0 0 20 15.1V6.25c0-.97-.78-1.75-1.75-1.75Z" />
              </svg>
            </span>
            หลักสูตรปกติ
          </button>
          <button
            type="button"
            id="compensation-summary-course-tab-international"
            class="segmented-tab compensation-summary-course-tab"
            role="tab"
            aria-controls="compensation-summary-course-panel"
            [attr.aria-selected]="activeCourseSummaryTab() === 'international'"
            [class.active]="activeCourseSummaryTab() === 'international'"
            (click)="onCourseSummaryTabChange('international')"
          >
            <span class="compensation-summary-course-tab-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" focusable="false">
                <circle cx="12" cy="12" r="8.5" />
                <path d="M3.8 12h16.4" />
                <path d="M12 3.5c2.15 2.32 3.22 5.15 3.22 8.5S14.15 18.18 12 20.5C9.85 18.18 8.78 15.35 8.78 12S9.85 5.82 12 3.5Z" />
              </svg>
            </span>
            หลักสูตรนานาชาติ
          </button>
        </div>

        <section
          class="compensation-summary-overview-section"
          [attr.aria-busy]="isLoading()"
          *ngIf="shouldShowOverview()"
        >
          <div class="compensation-summary-section-header compensation-summary-overview-header">
            <div>
              <h6>สรุปภาพรวม</h6>
              <p class="compensation-summary-section-description">
                คำนวณจากภาระงานสอนหลักสูตรปกติ
              </p>
            </div>
            <div class="compensation-summary-erp-imported-at">
              วันที่อัปเดตล่าสุด: {{ formatDateTime(summary().erp_comparison.imported_at) }}
            </div>
          </div>

          <div class="compensation-summary-calculation" aria-label="สรุปการคำนวณค่าตอบแทน">
            <article class="compensation-summary-calculation-card">
              <div class="compensation-summary-calculation-card-header">
                <span class="compensation-summary-calculation-step">1</span>
                <div>
                  <span class="compensation-summary-calculation-eyebrow">ขั้นตอนที่ 1</span>
                  <span class="compensation-summary-calculation-title">รวมชั่วโมงสอน</span>
                  <span class="compensation-summary-calculation-description">
                    ชั่วโมงที่นำมาใช้คำนวณในหลักสูตรปกติ
                  </span>
                </div>
              </div>

              <div class="compensation-summary-equation compensation-summary-equation-compact">
                <div class="compensation-summary-equation-term">
                  <span>สอนตามตาราง</span>
                  <strong>{{ formatHours(calculationTeachingWorkload()) }}</strong>
                </div>
                <span class="compensation-summary-equation-operator" aria-hidden="true">+</span>
                <div class="compensation-summary-equation-term">
                  <span>สอนชดเชย</span>
                  <strong>{{ formatHours(eligibleMakeupTeachingWorkload()) }}</strong>
                </div>
              </div>

              <div class="compensation-summary-card-outcome">
                <span>รวมสอนทั้งหมด</span>
                <strong>{{ formatHours(calculationTotalTeachingWorkload()) }}</strong>
              </div>
            </article>

            <article class="compensation-summary-calculation-card">
              <div class="compensation-summary-calculation-card-header">
                <span class="compensation-summary-calculation-step">2</span>
                <div>
                  <span class="compensation-summary-calculation-eyebrow">ขั้นตอนที่ 2</span>
                  <span class="compensation-summary-calculation-title">หักภาระงานขั้นต่ำ</span>
                  <span class="compensation-summary-calculation-description">
                    หาส่วนที่เกินจากเกณฑ์ภาระงานขั้นต่ำ
                  </span>
                </div>
              </div>

              <div class="compensation-summary-equation compensation-summary-equation-compact">
                <div class="compensation-summary-equation-term">
                  <span>รวมสอนทั้งหมด</span>
                  <strong>{{ formatHours(calculationTotalTeachingWorkload()) }}</strong>
                </div>
                <span class="compensation-summary-equation-operator" aria-hidden="true">−</span>
                <div class="compensation-summary-equation-term">
                  <span>ภาระงานขั้นต่ำ</span>
                  <strong>{{ formatHours(minimumTeachingWorkload()) }}</strong>
                </div>
              </div>

              <div
                class="compensation-summary-card-outcome"
                [class.compensation-summary-card-outcome-muted]="!hasPayableExcessHours()"
              >
                <span>ชั่วโมงเกินภาระงาน</span>
                <strong>{{ formatHours(calculationExcessHours()) }}</strong>
              </div>

              <div class="compensation-summary-card-status" *ngIf="!hasPayableExcessHours()">
                ยังไม่เกินภาระงานขั้นต่ำ
                <span *ngIf="calculationWorkloadShortfall() > 0">
                  (ขาดอีก {{ formatHours(calculationWorkloadShortfall()) }})
                </span>
              </div>
            </article>

            <article class="compensation-summary-calculation-card compensation-summary-calculation-card-result">
              <div class="compensation-summary-calculation-card-header">
                <span class="compensation-summary-calculation-step">3</span>
                <div>
                  <span class="compensation-summary-calculation-eyebrow">ขั้นตอนที่ 3</span>
                  <span class="compensation-summary-calculation-title">คำนวณค่าสอนเกินภาระงาน</span>
                  <span class="compensation-summary-calculation-description">
                    คิดตามชั่วโมงเบิกได้และอัตราของแต่ละระดับ
                  </span>
                </div>
              </div>

              <ng-container *ngIf="regularRateBreakdown() as breakdown">
                <div
                  class="compensation-summary-equation compensation-summary-equation-compact"
                  *ngIf="breakdown.length === 1"
                >
                  <div class="compensation-summary-equation-term">
                    <span>ชั่วโมงคิดเงิน</span>
                    <strong>{{ formatTableNumber(breakdown[0].payableHours) }}</strong>
                  </div>
                  <span class="compensation-summary-equation-operator" aria-hidden="true">×</span>
                  <div class="compensation-summary-equation-term">
                    <span>อัตรา</span>
                    <strong>{{ formatDisplayCurrency(breakdown[0].rate) }}</strong>
                  </div>
                </div>

                <div class="compensation-summary-rate-breakdown" *ngIf="breakdown.length > 1">
                  <div class="compensation-summary-rate-row" *ngFor="let item of breakdown">
                    <span class="compensation-summary-rate-level">{{ item.level }}</span>
                    <span class="compensation-summary-rate-formula">
                      <span>{{ formatTableNumber(item.payableHours) }} ชม.</span>
                      <span aria-hidden="true">×</span>
                      <span>{{ formatDisplayCurrency(item.rate) }} บาท</span>
                    </span>
                    <strong class="compensation-summary-rate-amount">
                      {{ formatDisplayCurrency(item.amount) }} บาท
                    </strong>
                  </div>
                </div>

                <div class="compensation-summary-no-payment" *ngIf="breakdown.length === 0">
                  <strong>0 บาท</strong>
                  <span>ยังไม่มีชั่วโมงที่นำไปคิดค่าสอนเกินภาระงาน</span>
                </div>
              </ng-container>

              <div class="compensation-summary-cap" *ngIf="isRegularCompensationCapped()">
                <span>ยอดรวมทั้งหมด {{ formatDisplayCurrency(regularRawCompensationAmount()) }} บาท</span>
                <span class="compensation-summary-cap-separator" aria-hidden="true">•</span>
                <strong>เบิกได้สูงสุด {{ formatDisplayCurrency(regularMaximumCompensationAmount()) }} บาท</strong>
              </div>

              <div class="compensation-summary-card-outcome compensation-summary-card-outcome-success">
                <span>ค่าสอนเกินภาระงานรวม</span>
                <strong>{{ formatDisplayCurrency(totalCompensationAmount()) }} บาท</strong>
              </div>
            </article>
          </div>
        </section>

        <section class="compensation-summary-course-section">
          <div
            id="compensation-summary-course-panel"
            class="compensation-summary-course-panel"
            role="tabpanel"
            [attr.aria-labelledby]="activeCourseSummaryTab() === 'regular'
              ? 'compensation-summary-course-tab-regular'
              : 'compensation-summary-course-tab-international'"
          >
            <div class="compensation-summary-course-header">
              <div>
                <h6>
                  {{ getCourseSummaryTitle() }}
                  <span>({{ getCourseSummaryDescription() }})</span>
                </h6>
              </div>
              <div class="compensation-summary-course-actions">
                <button
                  type="button"
                  class="compensation-summary-export-button"
                  [disabled]="isLoading() || pdfLoading()"
                  (click)="onOpenPdfPreview()"
                >
                  <span class="compensation-summary-export-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" focusable="false">
                      <path d="M14 3.5H7.25A1.75 1.75 0 0 0 5.5 5.25v13.5c0 .97.78 1.75 1.75 1.75h9.5c.97 0 1.75-.78 1.75-1.75V8l-4.5-4.5Z" />
                      <path d="M14 3.5V8h4.5" />
                      <path d="M9 13h6" />
                      <path d="M9 16h4" />
                    </svg>
                  </span>
                  Preview PDF
                </button>
              </div>
            </div>

            <ng-container *ngIf="activeCourseSummaryTab() === 'regular'; else internationalCourseTable">
              <section class="compensation-summary-course-subsection">
                <div class="compensation-summary-course-subsection-header">
                </div>

                <div
                  class="compensation-summary-course-empty"
                  *ngIf="regularSummaryTableDatasource.data.length === 0"
                >
                  ยังไม่มีข้อมูลสรุปหลักสูตรปกติสำหรับเทอมนี้
                </div>

                <div
                  class="compensation-summary-workload-table-scroll"
                  *ngIf="regularSummaryTableDatasource.data.length > 0"
                >
                  <table class="compensation-summary-workload-table compensation-summary-regular-summary-table">
                    <caption class="visually-hidden">สรุปค่าสอนเกินภาระงานหลักสูตรปกติ</caption>
                    <colgroup>
                      <col class="compensation-summary-regular-summary-level-column" />
                      <col class="compensation-summary-regular-summary-minimum-column" />
                      <col class="compensation-summary-regular-summary-scheduled-column" />
                      <col class="compensation-summary-regular-summary-makeup-column" />
                      <col class="compensation-summary-regular-summary-total-column" />
                      <col class="compensation-summary-regular-summary-excess-column" />
                      <col class="compensation-summary-regular-summary-rate-column" />
                      <col class="compensation-summary-regular-summary-amount-column" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th scope="col">ระดับ</th>
                        <th scope="col">ภาระงานสอนขั้นต่ำ</th>
                        <th scope="col">ภาระงานสอนตามตาราง</th>
                        <th scope="col">ขอสอนชดเชย</th>
                        <th scope="col">ภาระงานสอนทั้งหมด</th>
                        <th scope="col">ภาระงานสอนเกิน</th>
                        <th scope="col">อัตรา</th>
                        <th scope="col">ค่าสอนเกินภาระงาน</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let row of regularSummaryTableDatasource.data"
                        [class.compensation-summary-regular-summary-total-row]="row.rowType === 'total'"
                      >
                        <th scope="row">{{ row.level }}</th>
                        <td>{{ formatTableNumber(row.minimumHours) }}</td>
                        <td>{{ formatTableNumber(row.scheduledHours) }}</td>
                        <td>{{ formatTableNumber(row.makeupHours) }}</td>
                        <td>{{ formatTableNumber(row.totalHours) }}</td>
                        <td>{{ formatNonNegativeTableNumber(row.excessHours) }}</td>
                        <td>{{ formatRate(row.rateLabel) }}</td>
                        <td class="compensation-summary-regular-summary-amount">
                          {{ formatCurrency(row.compensationAmount) }}<ng-container *ngIf="row.rowType === 'total'"> บาท</ng-container>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>
            </ng-container>

            <ng-template #internationalCourseTable>
              <div class="compensation-summary-international-table-stack">
                <section class="compensation-summary-international-table-section">
                  <div class="compensation-summary-course-subsection-header">
                    <h6>ภาระงานสอนในหลักสูตรภาคปกติ</h6>
                  </div>

                  <div class="compensation-summary-workload-table-scroll">
                    <table class="compensation-summary-workload-table compensation-summary-regular-workload-table">
                      <caption class="visually-hidden">ภาระงานสอนในหลักสูตรภาคปกติ</caption>
                      <colgroup>
                        <col class="compensation-summary-workload-sequence-column">
                        <col class="compensation-summary-workload-subject-column">
                        <col class="compensation-summary-workload-level-column">
                        <col class="compensation-summary-workload-share-column">
                        <col class="compensation-summary-workload-group-column">
                        <col class="compensation-summary-workload-credit-column">
                        <col class="compensation-summary-workload-credit-column">
                        <col class="compensation-summary-workload-hours-column">
                      </colgroup>
                      <thead>
                        <tr>
                          <th rowspan="2" scope="col">ที่</th>
                          <th rowspan="2" scope="col">รายการ</th>
                          <th rowspan="2" scope="col">ระดับ</th>
                          <th
                            rowspan="2"
                            scope="col"
                            class="compensation-summary-workload-share-header"
                          >
                            สัดส่วนภาระงาน<br />
                            (ร้อยละ)
                          </th>
                          <th rowspan="2" scope="col">กลุ่ม</th>
                          <th colspan="2" scope="colgroup">หน่วยกิต</th>
                          <th rowspan="2" scope="col">ชั่วโมงทำการต่อสัปดาห์</th>
                        </tr>
                        <tr>
                          <th scope="col">Lec</th>
                          <th scope="col">Lab</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="compensation-summary-workload-group-row">
                          <th colspan="8" scope="rowgroup">
                            รายวิชาระดับปริญญาตรี/รายวิชาระดับบัณฑิตศึกษา
                          </th>
                        </tr>
                        <tr *ngFor="let row of regularWeeklyWorkloadRows(); let index = index">
                          <td class="compensation-summary-workload-center">{{ index + 1 }}</td>
                          <td>
                            <span class="compensation-summary-workload-subject">
                              <strong>{{ row.subject_code || '-' }}</strong>
                              <span>{{ row.subject_name || '-' }}</span>
                            </span>
                          </td>
                          <td class="compensation-summary-workload-center">{{ row.level_label || '-' }}</td>
                          <td class="compensation-summary-workload-center">
                            {{ formatWorkloadPercentage(row.workload_share_percentage) }}
                          </td>
                          <td class="compensation-summary-workload-center">{{ row.section || '-' }}</td>
                          <td class="compensation-summary-workload-center">
                            {{ formatOptionalTableNumber(row.lecture_credits) }}
                          </td>
                          <td class="compensation-summary-workload-center">
                            {{ formatOptionalTableNumber(row.laboratory_credits) }}
                          </td>
                          <td class="compensation-summary-workload-weekly-hours">
                            {{ row.weekly_hours === null ? '-' : formatTableNumber(row.weekly_hours) }}
                          </td>
                        </tr>
                        <tr *ngIf="regularWeeklyWorkloadRows().length === 0">
                          <td colspan="8" class="compensation-summary-workload-empty">
                            ยังไม่มีภาระงานสอนในหลักสูตรภาคปกติสำหรับเทอมนี้
                          </td>
                        </tr>
                        <tr class="compensation-summary-workload-group-row">
                          <th colspan="8" scope="rowgroup">
                            ควบคุมวิทยานิพนธ์หรือดุษฎีนิพนธ์
                          </th>
                        </tr>
                        <tr>
                          <td aria-hidden="true"></td>
                          <td colspan="2" class="compensation-summary-workload-detail">
                            - จำนวนนักศึกษาวิทยานิพนธ์หรือดุษฎีนิพนธ์
                          </td>
                          <td colspan="4" class="compensation-summary-workload-advisor-counts">
                            <div class="compensation-summary-workload-advisor-count-layout">
                              <span>
                                หลัก:
                                {{ formatTableNumber(
                                  regularProjectResearchPrimaryAdvisorStudentCount()
                                ) }}
                                / ร่วม:
                                {{ formatTableNumber(
                                  regularProjectResearchCoAdvisorStudentCount()
                                ) }}
                              </span>
                              <span>
                                รวม
                                {{ formatTableNumber(regularProjectResearchStudentCount()) }}
                                คน
                              </span>
                            </div>
                          </td>
                          <td class="compensation-summary-workload-weekly-hours">
                            {{ formatTableNumber(regularProjectResearchWeeklyHours()) }}
                          </td>
                        </tr>
                        <tr class="compensation-summary-workload-group-row">
                          <th colspan="8" scope="rowgroup">ภาระงานบริหาร</th>
                        </tr>
                        <tr>
                          <td aria-hidden="true"></td>
                          <td colspan="6" class="compensation-summary-workload-detail">
                            {{ administrationWorkloadLabel() }}
                          </td>
                          <td class="compensation-summary-workload-weekly-hours">
                            {{
                              hasAdministrationWorkload()
                                ? formatTableNumber(regularWeeklyWorkload().administration_weekly_hours)
                                : '-'
                            }}
                          </td>
                        </tr>
                        <tr class="compensation-summary-workload-group-row">
                          <th colspan="8" scope="rowgroup">ภาระงานสอนจากหลักสูตรนานาชาติ</th>
                        </tr>
                        <tr>
                          <td aria-hidden="true"></td>
                          <td colspan="6" class="compensation-summary-workload-detail">
                            - จำนวนภาระงานที่นำมาชดเชย
                          </td>
                          <td class="compensation-summary-workload-weekly-hours">
                            {{
                              formatTableNumber(
                                internationalWeeklyWorkload().total_offset_weekly_hours
                              )
                            }}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colspan="7" scope="row">รวมภาระงานภาคปกติคิดเป็นชั่วโมงทำการต่อสัปดาห์</th>
                          <td class="compensation-summary-workload-weekly-hours">
                            {{ formatTableNumber(regularWeeklyWorkloadDisplayTotal()) }} ชม./สัปดาห์
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </section>

                <section class="compensation-summary-international-table-section">
                  <div class="compensation-summary-course-subsection-header">
                    <h6>
                      ภาระงานสอนในหลักสูตรนานาชาติ
                    </h6>
                  </div>

                  <div class="compensation-summary-workload-table-scroll">
                    <table class="compensation-summary-workload-table compensation-summary-international-workload-table">
                      <caption class="visually-hidden">ภาระงานสอนในหลักสูตรนานาชาติ</caption>
                      <colgroup>
                        <col class="compensation-summary-workload-sequence-column" />
                        <col class="compensation-summary-workload-subject-column" />
                        <col class="compensation-summary-workload-level-column" />
                        <col class="compensation-summary-workload-share-column" />
                        <col class="compensation-summary-workload-group-column" />
                        <col class="compensation-summary-workload-credit-column" />
                        <col class="compensation-summary-workload-credit-column" />
                        <col class="compensation-summary-workload-compact-hours-column" />
                        <col class="compensation-summary-workload-compact-hours-column" />
                        <col class="compensation-summary-workload-compact-hours-column compensation-summary-workload-remaining-column" />
                        <col class="compensation-summary-workload-percentage-column compensation-summary-workload-remaining-column" />
                        <col class="compensation-summary-workload-percentage-column" />
                      </colgroup>
                      <thead>
                        <tr>
                          <th rowspan="2" scope="col">ที่</th>
                          <th rowspan="2" scope="col">รายการ</th>
                          <th rowspan="2" scope="col">ระดับ</th>
                          <th
                            rowspan="2"
                            scope="col"
                            class="compensation-summary-workload-share-header"
                          >
                            สัดส่วนภาระงาน<br />
                            (ร้อยละ)
                          </th>
                          <th rowspan="2" scope="col">กลุ่ม</th>
                          <th colspan="2" scope="colgroup">หน่วยกิต</th>
                          <th rowspan="2" scope="col">ชั่วโมงทำการ</th>
                          <th rowspan="2" scope="col">นำไปชดเชย</th>
                          <th colspan="2" scope="colgroup">คงเหลือ</th>
                          <th rowspan="2" scope="col">เหลือเบิกจ่าย</th>
                        </tr>
                        <tr>
                          <th scope="col">Lec</th>
                          <th scope="col">Lab</th>
                          <th scope="col">ชม.</th>
                          <th scope="col">ร้อยละ</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let row of internationalWeeklyWorkloadRows(); let index = index">
                          <td class="compensation-summary-workload-center">{{ index + 1 }}</td>
                          <td>
                            <span class="compensation-summary-workload-subject">
                              <strong>{{ row.subject_code || '-' }}</strong>
                              <span>{{ row.subject_name || '-' }}</span>
                            </span>
                          </td>
                          <td class="compensation-summary-workload-center">
                            {{ row.level_label || '-' }}
                          </td>
                          <td class="compensation-summary-workload-center">
                            {{ formatWorkloadPercentage(row.workload_share_percentage) }}
                          </td>
                          <td class="compensation-summary-workload-center">{{ row.section || '-' }}</td>
                          <td class="compensation-summary-workload-center">
                            {{ formatOptionalTableNumber(row.lecture_credits) }}
                          </td>
                          <td class="compensation-summary-workload-center">
                            {{ formatOptionalTableNumber(row.laboratory_credits) }}
                          </td>
                          <td class="compensation-summary-workload-number">
                            {{ formatOptionalTableNumber(row.weekly_hours) }}
                          </td>
                          <td class="compensation-summary-workload-number">
                            {{ formatOptionalTableNumber(row.offset_weekly_hours) }}
                          </td>
                          <td class="compensation-summary-workload-number">
                            {{ formatOptionalTableNumber(row.payable_weekly_hours) }}
                          </td>
                          <td class="compensation-summary-workload-number">
                            {{ formatWorkloadPercentage(remainingWeeklyPercentage(row)) }}
                          </td>
                          <td class="compensation-summary-workload-number">
                            {{ formatWorkloadPercentage(row.workload_share_percentage) }}
                          </td>
                        </tr>
                        <tr *ngIf="internationalWeeklyWorkloadRows().length === 0">
                          <td colspan="12" class="compensation-summary-workload-empty">
                            ยังไม่มีรายวิชาหลักสูตรนานาชาติสำหรับเทอมนี้
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                    
                      </tfoot>
                    </table>
                  </div>
                </section>

                <section class="compensation-summary-international-table-section">
                  <div class="compensation-summary-course-subsection-header">
                    <div>
                      <h6>ผลคำนวณค่าสอนเกินภาระงานจากเวลาสอนจริง</h6>
                      <p>ใช้ชั่วโมงตามตารางจริงและคำขอสอนชดเชยที่ Approved + ERP Matched</p>
                    </div>
                  </div>

                  <div
                    class="compensation-summary-course-empty"
                    *ngIf="internationalLineItemTableDatasource.data.length === 0"
                  >
                    ยังไม่มีรายละเอียดรายวิชาอินเตอร์สำหรับเทอมนี้
                  </div>

                  <div
                    *ngIf="internationalLineItemTableDatasource.data.length > 0"
                    class="compensation-summary-workload-table-scroll"
                  >
                    <table class="compensation-summary-workload-table compensation-summary-international-result-table">
                      <caption class="visually-hidden">
                        ผลคำนวณค่าสอนเกินภาระงานจากเวลาสอนจริงของหลักสูตรนานาชาติ
                      </caption>
                      <colgroup>
                        <col class="compensation-summary-international-result-subject-column" />
                        <col class="compensation-summary-international-result-type-column" />
                        <col class="compensation-summary-international-result-student-column" />
                        <col class="compensation-summary-international-result-scheduled-column" />
                        <col class="compensation-summary-international-result-makeup-column" />
                        <col class="compensation-summary-international-result-total-column" />
                        <col class="compensation-summary-international-result-calculation-rate-column" />
                        <col class="compensation-summary-international-result-payable-column" />
                        <col class="compensation-summary-international-result-amount-column" />
                      </colgroup>
                      <thead>
                        <tr>
                          <th rowspan="2" scope="col">รหัสวิชา / รายวิชา</th>
                          <th rowspan="2" scope="col">ประเภท</th>
                          <th rowspan="2" scope="col">จำนวนนักศึกษา</th>
                          <th rowspan="2" scope="col">ชั่วโมงตามตารางจริง</th>
                          <th rowspan="2" scope="col">ชั่วโมงชดเชย</th>
                          <th rowspan="2" scope="col">รวมชั่วโมง</th>
                          <th colspan="2" scope="colgroup">อัตราการเบิกจ่าย</th>
                          <th rowspan="2" scope="col">ค่าสอนเกินภาระงาน</th>
                        </tr>
                        <tr>
                          <th
                            scope="col"
                            class="compensation-summary-international-result-calculation-rate"
                          >
                            อัตราคิดเงินจริง
                           
                          </th>
                          <th scope="col">
                            เหลือเบิกจ่าย
                        
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let row of internationalLineItemTableDatasource.data"
                          [class.compensation-summary-international-result-total-row]="row.rowType === 'total'"
                        >
                          <th scope="row">
                            <span
                              class="compensation-summary-course-total-label"
                              *ngIf="row.rowType === 'total'; else internationalResultSubjectDetail"
                            >
                              {{ row.subjectCode }}
                            </span>
                            <ng-template #internationalResultSubjectDetail>
                              <span class="compensation-summary-international-subject">
                                <strong>{{ row.subjectCode }}</strong>
                                <span>{{ row.subjectName }}</span>
                              </span>
                            </ng-template>
                          </th>
                          <td>{{ row.rowType === 'total' ? '' : row.teachingType }}</td>
                          <td>{{ row.rowType === 'total' ? '' : formatStudents(row.studentCount) }}</td>
                          <td>{{ row.rowType === 'total' ? '' : formatTableNumber(row.scheduledHours) }}</td>
                          <td>{{ row.rowType === 'total' ? '' : formatTableNumber(row.makeupHours) }}</td>
                          <td>{{ row.rowType === 'total' ? '' : formatTableNumber(row.totalHours) }}</td>
                          <td class="compensation-summary-international-result-calculation-rate">
                            {{ row.rowType === 'total' ? '' : formatWorkloadPercentage(row.payablePercentage) }}
                          </td>
                          <td>
                            {{ row.rowType === 'total' ? '' : formatWorkloadPercentage(row.workloadSharePercentage) }}
                          </td>
                          <td class="compensation-summary-international-result-amount">
                            {{ formatCurrency(row.compensationAmount) }}<ng-container *ngIf="row.rowType === 'total'"> บาท</ng-container>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>
              </div>
            </ng-template>
          </div>
        </section>
      </div>

      <div
        id="compensation-summary-panel-requests"
        class="compensation-summary-tab-panel"
        role="tabpanel"
        aria-labelledby="compensation-summary-tab-requests"
        *ngIf="activeTab() === 'requests'"
      >
        <div class="compensation-summary-toolbar" [formGroup]="requestFilterForm">
          <div class="compensation-summary-filter">
            <app-select
              label="เทอมการศึกษา"
              formControlName="academicTerm"
              [options]="academicTermOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="compensation-summary-select"
              classes="mb-0"
            ></app-select>
          </div>

          <div class="compensation-summary-filter">
            <app-select
              label="ปีการศึกษา"
              formControlName="year"
              [options]="yearOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="compensation-summary-select"
              classes="mb-0"
            ></app-select>
          </div>
        </div>

        <section class="compensation-summary-erp-section">
          <div class="compensation-summary-section-header">
            <div>
              <h6>{{ getErpComparisonTitle() }}</h6>
            </div>
            <p class="compensation-summary-erp-notice">
              <span class="compensation-summary-erp-notice-icon" aria-hidden="true">!</span>
              {{ erpComparisonDescription }}
            </p>
          </div>

          <div class="compensation-summary-erp-empty" *ngIf="!summary().erp_comparison.has_result">
            ยังไม่มีผลตรวจข้อมูล ERP สำหรับเทอมนี้
          </div>

          <div
            class="compensation-summary-state compensation-summary-state-error"
            *ngIf="summary().erp_comparison.has_result && hasErpComparisonDetailError()"
          >
            ไม่สามารถโหลดรายละเอียดผลตรวจข้อมูล ERP ได้ กรุณาลองใหม่อีกครั้ง
          </div>

          <section
            class="compensation-summary-comparison-section"
            *ngIf="summary().erp_comparison.has_result"
          >
            <div
              class="compensation-summary-comparison-loading"
              *ngIf="!hasErpComparisonDetailError() && isLoadingErpComparisonDetail() && !erpComparisonDetail"
            >
              กำลังโหลดผลการเปรียบเทียบ...
            </div>

            <div
              class="compensation-summary-comparison-scroll"
              *ngIf="erpComparisonDetail"
            >
              <app-datatable
                class="compensation-summary-comparison-datatable"
                [datasource]="comparisonTableDatasource"
                [columns]="comparisonColumns"
                [isLoading]="isLoadingErpComparisonDetail()"
                [limit]="comparisonTableDatasource.limit"
                [showOrder]="false"
                [externalSorting]="true"
                [horizontalScrollWhenEmpty]="true"
                [maxVisibleRows]="5"
                (sortChange)="onComparisonSortChange($event)"
              ></app-datatable>

              <app-table-pagination
                [page]="comparisonTableDatasource.page"
                [limit]="comparisonTableDatasource.limit"
                [total]="comparisonTableDatasource.total"
                [totalPage]="comparisonTableDatasource.total_page"
                [offset]="comparisonTableDatasource.offset"
                [dataLength]="comparisonTableDatasource.data.length"
                [pageSizeOptions]="comparisonPageSizeOptions"
                ariaLabel="compensation summary ERP comparison pagination"
                (pageChange)="onComparisonPageChange($event)"
                (limitChange)="onComparisonLimitChange($event)"
              ></app-table-pagination>
            </div>
          </section>
        </section>
      </div>
      </div>
    </div>
  </div>
</div>

<ng-template #emptyComparisonCell>
  <span class="compensation-summary-comparison-empty">-</span>
</ng-template>

<div
  class="compensation-summary-pdf-modal-overlay"
  *ngIf="isPdfPreviewModalOpen()"
  role="dialog"
  aria-modal="true"
  aria-labelledby="compensation-summary-pdf-modal-title"
>
  <div class="compensation-summary-pdf-modal-panel">
    <div class="compensation-summary-pdf-modal-header">
      <h5 id="compensation-summary-pdf-modal-title">{{ pdfPreviewTitle() }}</h5>
      <button
        type="button"
        class="btn-close"
        aria-label="ปิด"
        (click)="onClosePdfPreview()"
      ></button>
    </div>
    <div class="compensation-summary-pdf-modal-body">
      <div class="compensation-summary-pdf-state" *ngIf="pdfLoading()">
        กำลังโหลด PDF...
      </div>
      <div class="compensation-summary-pdf-state" *ngIf="!pdfLoading() && pdfError()">
        ไม่สามารถโหลด PDF ได้ กรุณาลองใหม่อีกครั้ง
      </div>
      <iframe
        *ngIf="!pdfLoading() && !pdfError() && pdfPreviewUrl() as previewUrl"
        class="compensation-summary-pdf-preview"
        [src]="previewUrl"
        [attr.title]="pdfPreviewTitle()"
      ></iframe>
    </div>
    <div class="compensation-summary-pdf-modal-footer">
      <button type="button" class="btn btn-light" (click)="onClosePdfPreview()">ปิด</button>
    </div>
  </div>
</div>
